import { $authHost } from "./index";

export const getUploads = async () => {
  const { data } = await $authHost.get("/api/uploads");

  return data;
};